import styled from '@emotion/styled';

export const SectionText = styled.div<{ textAlign?: 'left' | 'right' | 'center' }>(
    ({ textAlign = 'left', theme }) => ({
        '.textRawHtml_customStyle': {
            textAlign,
            fontWeight: theme.mixins.useFontWeight('Regular'),
            ...theme.mixins.useTextStyle('bodySmall'),
        },
    }),
);
